import { observer } from "mobx-react-lite"
import { store } from "../../../../../stores/Store"
import Panel from "../../../../layout/Panel"
import PanelBody from "../../../../layout/PanelBody"
import PanelHeader from "../../../../layout/PanelHeader"
import PanelLabel from "../../../../layout/PanelLabel"
import { DetailPanelProps } from "../DetailPanel"
import ReportSection from "../report/ReportSection"
import EnquiryDataSourcesSection from "./EnquiryDataSourcesSection"
import EnquiryDetailSection from "./EnquiryDetailSection"
import EnquiryStatusIndicator from "./EnquiryStatusIndicator"
import NextStepsSection from "./NextStepsSection"
import EnquiryApplicationSection from "./EnquiryApplicationSection"
import EnquiryOutcomeDetails from "./EnquiryOutcomeDetails"
import React from "react"
import { Button } from "@mui/material"
import EnquiryCta from "./EnquiryCta"


export default observer(function EnquiryDetail ({index}: DetailPanelProps) {

    const {enquiry, getSubject} = store.EnquiryStore

    return (
        <Panel index={index} id="DETAIL" className="detail" width="none" loadingContent={!enquiry}>

            <PanelLabel title="Assessment details" />

            <PanelHeader 
                closeable 
                node={enquiry} 
                title={`Assessment for ${getSubject(enquiry).name}`} 
                onClose={() => store.NodeStore.setLeafNode(null)}>
                <EnquiryStatusIndicator enquiry={enquiry} />
            </PanelHeader>

            <PanelBody>
                <div className="panel-columns enquiry-detail">
                    <div>
                        <EnquiryCta />
                        <EnquiryDetailSection enquiry={enquiry} />
                        <OutcomeSection enquiry={enquiry} />
                    </div>

                    <div>
                        <ReportSection />
                        <EnquiryApplicationSection enquiry={enquiry} />
                        <EnquiryDataSourcesSection />
                    </div>
                </div>
            </PanelBody>

        </Panel>
    )
})


function OutcomeSection ({enquiry}) {

    const [truncated, setTruncated] = React.useState(true)
    const [truncatable, setTruncatable] = React.useState(true)
    const ref = React.useRef(null)
    const truncatedHeight = 240

    React.useEffect(() => {
        if (ref.current) {
            setTruncatable(ref.current.scrollHeight > ref.current.clientHeight)
        }
    }, [])

    if (typeof enquiry.additionalOutcomeData !== 'object' || !Object.keys(enquiry.additionalOutcomeData).length) return <></>

    return (
        <div className="detail-section">
            <div className="header">
                <h4>Outcome details</h4>

                {truncatable ? (
                    <Button className="btn btn-sm" onClick={() => setTruncated(!truncated)}>{truncated ? "See more" : "See less"}</Button>
                ) : null}
            </div>

            <div ref={ref} style={{
                overflowY: "auto",
                marginTop: "10px",
                maxHeight: truncatable && truncated ? `${truncatedHeight}px` : "none", 
                boxShadow: truncatable && truncated ? "rgba(0, 0, 0, 0.21) 0px -45px 46px -33px inset" : "none", 
            }}>
                <EnquiryOutcomeDetails enquiry={enquiry} />
            </div>
        </div>
    )
}